import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { ThemeContext } from "../../common/theme/ThemeContext";
import "./City.scss";

function City({ children, link = "/", name }) {
  const theme = useContext(ThemeContext);
  return (
    <div className="navbar-item">
      <NavLink
        to={link}
        activeClassName={theme.cityClass}
        className={`is-size-3-desktop is-size-3-touch has-text-${theme.navColor}-${theme.navText}`}
      >
        <span>{name}</span>
      </NavLink>
      <span>{children}</span>
    </div>
  );
}

export default City;
